import { CommonModule, DatePipe } from '@angular/common';
import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ProductionKeyPerformanceIndicatorEvaluation } from 'src/app/models/production-key-performance-indicator-evaluation.model';
import { UptimeMonitorsKpiData } from 'src/app/models/uptime-monitors-kpi-data.model';
import { SecondsToHourStringPipe } from 'src/app/pipes/seconds-to-hour-string.pipe';

@Component({
  selector: 'app-uptime-monitors-details',
  imports: [CommonModule, DatePipe, MatTooltipModule, SecondsToHourStringPipe],
  templateUrl: './uptime-monitors-details.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './uptime-monitors-details.component.css',
})
export class UptimeMonitorsDetailsComponent {
  currentMonthEvaluation = input<ProductionKeyPerformanceIndicatorEvaluation | null>(null);

  uptimeData = computed<UptimeMonitorsKpiData>((): UptimeMonitorsKpiData => {
    const rawData = this.currentMonthEvaluation()?.data;
    return UptimeMonitorsDetailsComponent.isUptimeMonitorsKpiData(rawData) ? rawData : this.getEmptyUptimeData();
  });

  private getEmptyUptimeData(): UptimeMonitorsKpiData {
    return {
      tooltip_summary: '',
      active_company_product_status_monitors_count: 0,
      valid_monitors_count: 0,
      uptime_seconds: 0,
      monitored_seconds: 0,
      uptime_monitor_items: [],
    };
  }

  private static isUptimeMonitorsKpiData(value: unknown): value is UptimeMonitorsKpiData {
    if (typeof value !== 'object' || value === null || Array.isArray(value)) {
      return false;
    }

    const candidate = value as Partial<UptimeMonitorsKpiData>;

    return (
      typeof candidate.active_company_product_status_monitors_count === 'number' &&
      typeof candidate.uptime_seconds === 'number' &&
      typeof candidate.monitored_seconds === 'number' &&
      typeof candidate.valid_monitors_count === 'number' &&
      Array.isArray(candidate.uptime_monitor_items)
    );
  }
}
